"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _reactCollapse = require("react-collapse");

var _uiKit = require("@dbi-tools/ui-kit");

var _minusThin = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/minus-thin"));

var _plusThin = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/plus-thin"));

var _useMedia = require("../../hooks/use-media");

var _themeOptions = require("../../helpers/theme-options");

var _const = require("../../const");

var _headerTitles = require("../header-titles");

var _lazyLoadImage = require("../lazy-load-image");

var _linkButtons = _interopRequireDefault(require("../link-buttons"));

var _faqHub = require("./faq-hub.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FaqHub = function FaqHub(props) {
  var headline1 = props.headline1,
      headline2 = props.headline2,
      description = props.description,
      removeTopPadding = props.removeTopPadding,
      removeBottomPadding = props.removeBottomPadding,
      buttons = props.buttons,
      sections = props.sections;
  var currentTheme = _themeOptions.ThemeVariants.WHITE;
  var _themeStrategy$curren = _themeOptions.themeStrategy[currentTheme],
      headline1Color = _themeStrategy$curren.headline1Color,
      headline2Color = _themeStrategy$curren.headline2Color;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      openSection = _useState2[0],
      setOpenSection = _useState2[1];

  var isDesktop = (0, _useMedia.useMedia)(_const.Breakpoints.DESKTOP);
  var btnColor = 'gray800';
  var iconSize = isDesktop ? 18 : 14;
  var theme = {
    $theme: currentTheme,
    $descriptionLinkColor: 'wine'
  };

  if (!headline1 && !headline2 && !description && (0, _isEmpty.default)(buttons) && (0, _isEmpty.default)(sections)) {
    return /*#__PURE__*/_react.default.createElement(_uiKit.Heading, {
      align: "center",
      as: "h2",
      fontWeight: "bold",
      measure: "h1"
    }, "Please configure FAQ Hub component");
  }

  var desktopView = function desktopView(_ref) {
    var fileReference = _ref.fileReference,
        sectionTitle = _ref.sectionTitle,
        nestedLinks = _ref.nestedLinks,
        altText = _ref.altText;
    return /*#__PURE__*/_react.default.createElement(_faqHub.SectionStyled, {
      display: "flex",
      alignItems: "start"
    }, /*#__PURE__*/_react.default.createElement(_faqHub.SectionIconStyled, null, /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
      src: fileReference,
      placeholderSrc: fileReference,
      alt: altText
    })), /*#__PURE__*/_react.default.createElement(_faqHub.SectionBodyStyled, null, /*#__PURE__*/_react.default.createElement(_uiKit.Heading, {
      as: "h5",
      fontWeight: "bold",
      fontSize: 24,
      lineHeight: 36,
      color: btnColor,
      m: [0]
    }, sectionTitle), /*#__PURE__*/_react.default.createElement(_faqHub.LinksListStyled, null, nestedLinks && nestedLinks.map(function (_ref2, index) {
      var link = _ref2.link,
          text = _ref2.text;
      return /*#__PURE__*/_react.default.createElement(_faqHub.LinksListItemStyled, {
        key: index,
        p: [10, 0]
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        href: link,
        color: btnColor,
        variant: "link",
        as: "a",
        measure: "sm",
        align: "left"
      }, text));
    }))));
  };

  var mobileView = function mobileView(_ref3, index) {
    var fileReference = _ref3.fileReference,
        sectionTitle = _ref3.sectionTitle,
        nestedLinks = _ref3.nestedLinks;
    var isOpen = openSection === index;
    return /*#__PURE__*/_react.default.createElement(_faqHub.SectionStyled, null, /*#__PURE__*/_react.default.createElement(_faqHub.SectionHeadStyled, {
      onClick: function onClick() {
        return setOpenSection(!isOpen && index);
      }
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_faqHub.SectionIconStyled, null, /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
      src: fileReference,
      placeholderSrc: fileReference,
      alt: "Icon"
    })), /*#__PURE__*/_react.default.createElement(_uiKit.Heading, {
      as: "h5",
      fontWeight: "bold",
      fontSize: 18,
      lineHeight: 27,
      color: btnColor,
      m: [0]
    }, sectionTitle)), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      variant: "link",
      color: btnColor
    }, isOpen ? /*#__PURE__*/_react.default.createElement(_minusThin.default, {
      measure: iconSize
    }) : /*#__PURE__*/_react.default.createElement(_plusThin.default, {
      measure: iconSize
    }))), /*#__PURE__*/_react.default.createElement(_faqHub.SectionBodyStyled, null, /*#__PURE__*/_react.default.createElement(_reactCollapse.Collapse, {
      isOpened: isOpen
    }, /*#__PURE__*/_react.default.createElement(_faqHub.LinksListStyled, null, nestedLinks && nestedLinks.map(function (_ref4, index) {
      var link = _ref4.link,
          text = _ref4.text;
      return /*#__PURE__*/_react.default.createElement(_faqHub.LinksListItemStyled, {
        key: index,
        p: [10, 0]
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        href: link,
        color: btnColor,
        variant: "link",
        as: "a",
        measure: "sm",
        align: "left"
      }, text));
    })))));
  };

  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_faqHub.ContainerStyled, {
    removeTopPadding: removeTopPadding,
    removeBottomPadding: removeBottomPadding,
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_FAQ_HUB
  }, /*#__PURE__*/_react.default.createElement(_headerTitles.HeaderTitles, {
    headline1: headline1,
    headline2: headline2,
    headline1Color: headline1Color,
    headline2Color: headline2Color,
    description: description
  }), !(0, _isEmpty.default)(sections) && /*#__PURE__*/_react.default.createElement(_faqHub.SectionsStyled, null, /*#__PURE__*/_react.default.createElement(_uiKit.Row, null, sections.map(function (section, index) {
    return /*#__PURE__*/_react.default.createElement(_faqHub.SectionColStyled, {
      lg: 6,
      key: index
    }, isDesktop ? desktopView(section) : mobileView(section, index));
  }))), !(0, _isEmpty.default)(buttons) && /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    display: "inline-block",
    align: "center",
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
    buttons: buttons,
    mt: 45
  }))));
};

var _default = FaqHub;
exports.default = _default;